export const KpisHeader = () => {
    return (
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-6">
            <div>
                <h1 className="text-4xl font-black text-primary tracking-tight mb-2 font-headline">
                    KPI Calculation Methodology
                </h1>
                <p className="text-on-surface-variant font-medium">
                    How player performance scores are calculated and weighted.
                </p>
            </div>
        </div>
    );
};
